import styles from "./Radio.module.scss"
import cx from "classnames"
import FieldDescription from "../FieldDescription"

const RadioField = ({ field, methods, className, inputClassName }) => {
  const { label, value, name, description } = field
  const { register } = methods

  return (
    <label className={cx(styles.label, className)}>
      <div className="flex items-center">
        <input
          className={cx(styles.input, inputClassName)}
          type="radio"
          value={value}
          {...register(name)}
        />

        {label}
      </div>

      {description && <FieldDescription description={description} />}
    </label>
  )
}

export default RadioField
